import { WBBox, WBFlex, WBSkeleton } from '@admiin-com/ds-web';
import { styled } from '@mui/material';
import React from 'react';

interface Props {
  noBorderTop?: boolean;
}

export const FileUploadSkeleton = React.forwardRef<HTMLDivElement, Props>(
  ({ noBorderTop }, ref) => {
    return (
      <Container ref={ref} sx={{ borderTopWidth: noBorderTop ? 0 : 2 }}>
        <WBFlex justifyContent={'space-between'}>
          <WBFlex alignItems={'center'} gap={1}>
            <WBSkeleton variant="rectangular" width={24} height={24} />
            <WBBox>
              <WBSkeleton variant="text" width={180} height={20} />
              <WBSkeleton variant="text" width={80} height={16} />
            </WBBox>
          </WBFlex>
          <WBSkeleton variant="circular" width={32} height={32} />
        </WBFlex>
      </Container>
    );
  }
);

FileUploadSkeleton.displayName = 'FileUploadSkeleton';

const Container = styled(WBBox)(({ theme }) => ({
  borderTopColor: theme.palette.divider,
  borderTopStyle: 'solid',
  borderTopWidth: 2,
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));
